import queryString from 'query-string';

export const getQueryObj = search => {
    return queryString.parse(search);
};

export const redirectIQ = _ => window.location.href = '/home';

export const isWeekend = date => {
    const createDate = new Date(date);
    const dayOfWeek = createDate.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
};

export const disableDates = args => {
    const dayOfWeek = args.date.getDay();
    const isWeekend = args.view === 'month' && (dayOfWeek === 0 || dayOfWeek === 6);

    return isWeekend;
};

export const setSessionStorage = (key, value) => {
    return new Promise((resolve, reject) => {
        try {
            sessionStorage.setItem(key, value);
            resolve('Successfully set ' + key);
        } catch (error) {
            reject('Error setting ' + key + ': ' + error.message);
        }
    });
};

const isValidPercentage = (value) => {
    if (value === null || value === undefined || value === '') {
        return false;
    }

    const num = typeof value === 'number' ? value : Number(value);
    return !isNaN(num) && isFinite(num);
};

export const SCORE_TYPE = {
    IN: 'in',
    OUT: 'out'
};

export const calculateBlueskyScorePercentage = (scoreIn, scoreOut, calculateWhichScore = SCORE_TYPE.IN) => {
    // Only return a percentage if both scores are valid numbers. If one is missing or invalid, assume both are invalid.
    const hasValidScores = isValidPercentage(scoreIn) && isValidPercentage(scoreOut);

    if (!hasValidScores) {
        return undefined;
    }

    const score = calculateWhichScore === SCORE_TYPE.IN ? scoreIn : scoreOut;
    return `${(score * 100).toFixed(0)}`;
};